export default __webpack_public_path__ + "static/media/conteudo_extra_17_29.60c6150b.jpg";